module.exports = __webpack_public_path__ + "img/duoren.55bcdb5c.png";